/**
 * Service for age verification and profile verification status/settings.
 *
 * Responsibilities:
 * - Start age verification flow and check its status.
 * - Fetch age gate settings.
 * - Fetch verification status for user profile.
 */
import type {
  IAgeGateSettingsResponse,
  VerifyResponse,
} from "../types";

import type { ApiClient } from "@/common/api/http/types";

export default class VerificationService {
  public constructor(private readonly client: ApiClient) {}

  async getAgeGateSettings(): Promise<IAgeGateSettingsResponse> {
    return await this.client.get("/v2/me/settings/age-gate");
  }

  async getVerifyUserStatus(): Promise<VerifyResponse> {
    return await this.client.get("v2/me/verify-profile");
  }

  async verifyAgeWithToken(token: string): Promise<void> {
    return await this.client.post("/v2/verification/idv/token/verify", {
      token,
    });
  }

  async linkToken(token: string): Promise<void> {
    return await this.client.post("/v2/verification/idv/token/link", {
      token,
    });
  }
}
